import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '@core/auth/user/user.service';
import { environment } from 'src/environments/environment';

export const uploadImageInterceptor: HttpInterceptorFn = (req, next) => {
  if (!(req.url.includes('imageupload/upload_img_web') || req.body instanceof FormData)) {
    return next(req);
  }

  const userService = inject(UserService);


  // Collect Authorization header from user session (if exists)
  const headers: Record<string, string> = {};
  const sessionToken = userService.getPartialData('loginsession');
  if (sessionToken) {
    headers['Authorization'] = String(sessionToken);
  }
  const formData = req.body as FormData;
  formData.append('token', environment.staticToken);
  formData.append('access_mode', environment.access_mode);

  const cloneReq = req.clone({ setHeaders: headers, body: formData });
  return next(cloneReq);
};
